import { render, staticRenderFns } from "./CreateBuilding.vue?vue&type=template&id=a791f96c&"
import script from "./CreateBuilding.vue?vue&type=script&lang=ts&"
export * from "./CreateBuilding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports